export default {
  PRIMARY: "primary Hero Item",
  SECONDARY: "secondary Hero Item",
};
